const STORAGE_BASE = 'https://firmendata.com/storage/';

/**
 * Construct public URL for objects in the public storage bucket (e.g. company website favicons or linkedin logo url).
 *
 * Idempotent: full URLs (http/https) are returned as-is so this can safely
 * wrap values that the backend may have already resolved.
 *
 * Works both server-side and client-side.
 */
export function getPublicStorageUrl(
  storageKey: string | null | undefined,
): string | undefined {
  if (!storageKey) return undefined;

  // Already a full URL — pass through unchanged
  if (storageKey.startsWith('http://') || storageKey.startsWith('https://')) {
    return storageKey;
  }

  return `${STORAGE_BASE}${storageKey}`;
}
